import React from 'react'

import './RecommendVideo.css';
import VideoCard from './Video/VideoCard';

const RecommendVideo = () => {
    return (
        <div className="recommendVideo">
            <h2>Recommended</h2>
            <div className="recommendVideo__videos">
                <VideoCard 
                    title="Norway AMAZING Beautiful Nature with Relaxing Music and sound, 4k Ultra HD| Europe beautiful"
                    views="7,339,810 views"
                    timestamp="7 months ago"
                    channelImage="https://yt3.ggpht.com/ytc/AAUvwngFdQC3gzSlXOoyLsFL8kPeWFI-hz9C8mKR4GEeFA=s88-c-k-c0x00ffffff-no-rj"
                    channel="ChonoLight"
                    image={`https://i.ytimg.com/vi/SMKPKGW083c/hqdefault.jpg?sqp=-oaymwEZCOADEI4CSFXyq4qpAwsIARUAAIhCGAFwAQ==&amp;rs=AOn4CLBSEClxPK3MqcFgj2-BY3B-K-Gq5Q`}
                />


                <VideoCard 
                    title="【4K】26 Countries of Beautiful EUROPE from Above 2020 | Cinematic Wolf Aerial™ Drone Film"
                    views="7,339,810 views"
                    timestamp="8 months ago"
                    channelImage="https://yt3.ggpht.com/ytc/AAUvwnjFUdapr9974u8cKnJ23NKj5dF3XJd-OMRCntNmsQ=s48-c-k-c0xffffffff-no-rj-mo"
                    channel="One Man Wolf Pack"
                    image={`https://i.ytimg.com/vi/oyFS7mb0zOI/hq720.jpg?sqp=-oaymwEZCOgCEMoBSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLC0ZKdufgIHCwiQPRaZMjFdCqZ2Mg`}
                />


                <VideoCard 
                    title="7 Days in Europe - Switzerland, France, Germany - 5d Mark III Magic Lantern RAW video"
                    views="4,045,818 views"
                    timestamp="5 years ago"
                    channelImage="https://yt3.ggpht.com/ytc/AAUvwnhg582k_SKo2-D0cMZqDUz5F9FSWaN-5THL3snXgQ=s48-c-k-c0xffffffff-no-rj-mo"
                    channel="Andrii Sirenko"
                    image={`https://i.ytimg.com/vi/UnKJL_ifwkk/hq720.jpg?sqp=-oaymwEZCOgCEMoBSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLA1B2nDiKbRviPQQ1JraHa-FgCi9A`}
                />



                <VideoCard 
                    title="Top 100 Places To Visit In Europe"
                    views="2,793,837 views"
                    timestamp="2 months ago"
                    channelImage="https://yt3.ggpht.com/ytc/AAUvwnj2NQaGAQzDbTD1gIqc6VWHbYrPpAbSGtxQbw3a-A=s48-c-k-c0xffffffff-no-rj-mo"
                    channel="Ryan Shirley"
                    image={`https://i.ytimg.com/vi/ixIzimI35SE/hq720.jpg?sqp=-oaymwEZCOgCEMoBSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLDpDLDCz-ABjbpU0_Padnnb9Pi2wA`}
                />


                <VideoCard 
                    title="25 Best Places to Visit in Europe - Travel Europe"
                    views="7,863,715 views"
                    timestamp="1 years ago"
                    channelImage="https://yt3.ggpht.com/ytc/AAUvwngPdPPmjR3-YpjhRPLTl4XOw0CkUlbAqXI0kKj1=s48-c-k-c0xffffffff-no-rj-mo"
                    channel="touropia"
                    image={`https://i.ytimg.com/vi/0GZSfBuhf6Y/hq720.jpg?sqp=-oaymwEZCOgCEMoBSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLBGzfFXpBY3Gu65NbLPtKpZAMyihA`}
                />


                <VideoCard 
                    title="【4K】Drone Footage | The Beauty of EUROPE in 45 Minutes 2019 | Cinematic Aerial Film"
                    views="159,727 views"
                    timestamp="1 years ago"
                    channelImage="https://yt3.ggpht.com/ytc/AAUvwnjFUdapr9974u8cKnJ23NKj5dF3XJd-OMRCntNmsQ=s48-c-k-c0xffffffff-no-rj-mo"
                    channel="One Man Wolf Pack"
                    image={`https://i.ytimg.com/vi/q_fvooJMw90/hq720.jpg?sqp=-oaymwEZCOgCEMoBSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLCDGtVoop-vZVG38z6eRFNcI728BA`}
                />


                <VideoCard 
                    title="Discovering New Zealand in Ultra HD | Best Places to Visit in New Zealand 2019"
                    views="212,362 views"
                    timestamp="6 months ago"
                    channelImage="https://yt3.ggpht.com/ytc/AAUvwnjPzRlB71xIIGp3fFDvN_9R_EIHyGefTnguMjfaUg=s48-c-k-c0xffffffff-no-rj-mo"
                    channel="Sovereign Digital"
                    image={`https://i.ytimg.com/vi/zeb0L5hEjn8/hq720.jpg?sqp=-oaymwEZCOgCEMoBSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLBSV9ac3M2nPB1S1m06kCS47_eA6Q`}
                />


                <VideoCard 
                    title="New Zealand in 4K Ultra HD"
                    views="2,760,793 views"
                    timestamp="2 months ago"
                    channelImage="https://yt3.ggpht.com/ytc/AAUvwngyDBIbtAY_lvIXTHY0vLZrqwd-ZMAcbRIuFIs2AA=s48-c-k-c0xffffffff-no-rj-mo"
                    channel="Amazing Places on Our Planet"
                    image={`https://i.ytimg.com/vi/8jypK2U1AM0/hq720.jpg?sqp=-oaymwEZCOgCEMoBSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLDDFGGk5b34sqfLxADpCrpExwbLug`}
                />

                <VideoCard 
                    title="10 Best Places to Visit in New Zealand"
                    views="2,151,836 views"
                    timestamp="9 months ago"
                    channelImage="https://yt3.ggpht.com/ytc/AAUvwngPdPPmjR3-YpjhRPLTl4XOw0CkUlbAqXI0kKj1=s48-c-k-c0xffffffff-no-rj-mo"
                    channel="touropia"
                    image={`https://i.ytimg.com/vi/EdKDIph5IaM/hq720.jpg?sqp=-oaymwEZCOgCEMoBSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLBE29oVZMIqiHPvaGthPY8l2KIZ5g`}
                />

                <VideoCard 
                    title="New Zealand: The Ultimate Travel Guide by TourRadar 5/5"
                    views="2,129,050 views"
                    timestamp="2 months ago"
                    channelImage="https://yt3.ggpht.com/ytc/AAUvwnhpakP6cJW3gsRQoSZglOpTQUGbF0hgrUhfcI77tA=s48-c-k-c0xffffffff-no-rj-mo"
                    channel="TourRadar"
                    image={`https://i.ytimg.com/vi/_eMAXOp2PvA/hq720.jpg?sqp=-oaymwEZCOgCEMoBSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLCLhQble2SxAR1rOUszEt8ODf4tfA`}
                />

                <VideoCard 
                    title="New Zealand Winter"
                    views="129,378 views"
                    timestamp="1 week ago"
                    channelImage="https://yt3.ggpht.com/ytc/AAUvwnioE5O6Yks-J6M1hSV5AYBQOTmX2t1wGcIw2UqsTw=s48-c-k-c0xffffffff-no-rj-mo"
                    channel="Beautiful Destinations"
                    image={`https://i.ytimg.com/vi/ubVWxQIuh8g/hq720.jpg?sqp=-oaymwEZCOgCEMoBSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLBOPPpLjIK0_8as94IrUb4dSJXTEQ`}
                />

                <VideoCard 
                    title="BEAUTIFUL SCOTLAND (Highlands / Isle of Skye) AERIAL DRONE 4K VIDEO"
                    views="6,957,603 views"
                    timestamp="5 months ago"
                    channelImage="https://yt3.ggpht.com/ytc/AAUvwnggEHKFKKlrnZhwJyBK2tlF4W6DREWd3oTMaCGPug=s48-c-k-c0xffffffff-no-rj-mo"
                    channel="Stefan Zimmermann"
                    image={`https://i.ytimg.com/vi/sb6WlQiaJeM/hq720.jpg?sqp=-oaymwEZCOgCEMoBSFXyq4qpAwsIARUAAIhCGAFwAQ==&rs=AOn4CLBRhf12KbyDCSt4HTVXc8VDSJX3Gw`}
                />
            </div>
        </div>
    )
}

export default RecommendVideo
